import { ArticleModuleHeroSidebarSection } from '#components/Article/Modules/ArticleModuleHeroSidebarSection';

import { ArticleSectionTags } from '../Sections/ArticleSectionTags';
import type { ArticleSectionTagsFragment } from '../Sections/__generated__/ArticleSectionTags.generated';

type Props = {
	tags: ArticleSectionTagsFragment[];
};

/**
 * Generates a container component for the ArticleModuleHeroSidebarSectionTags.
 *
 * @param tags The tags to be displayed in the container.
 * @return  The rendered container component.
 */
export function ArticleModuleHeroSidebarSectionTags({ tags }: Props) {
	return (
		<ArticleModuleHeroSidebarSection title="Schlagwörter">
			<ArticleSectionTags tags={tags} className="amhsst-gtm" data-theme-area="light" />
		</ArticleModuleHeroSidebarSection>
	);
}
